/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export class UnitTest {
    private app: any;
    constructor(app: any) {
        this.app = app.getInstance();
    }

    async run() {
        await this.eventBusTest();
        await this.dummyGraphQlQuery();
    }

    async eventBusTest() {
        //------------->>>>>--------------//
        const ebModule = this.app.getSync("services.EventBusModule");
        const eb = ebModule?.getEventBus();
        eb.on("test-event", function (payload: any) {
            console.log("event received", payload);
        });
        eb.emit("test-event", null, {
            message: "Hello From vlinder unit test",
        });
        //------------->>>>>--------------//
    }

    async dummyGraphQlQuery() {
        //------------->>>>>--------------//
        const dummyGraphqlService = this.app.getSync(
            'services.DummyGraphQLService',
        );
        await dummyGraphqlService.dummyQuery();
        //------------->>>>>--------------//
    }
}
